export default __webpack_public_path__ + "static/media/plockuzzle.8c2f0296.png";